export default "__VITE_ASSET__Blm3XQw4__"